export const supabaseUrl = 'https://ush-supabase-u13558.vm.elestio.app';
export const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzI3MjcxODQwLCJleHAiOjIwNDI2MzE4NDB9.2BwIlgb7PkauLWV73yLlKRNJs6_piIjWY2MnJmF0uHw';
export const openCageKey = 'dc0abaad2d9943ce938ee69fead70a72';
export const postmarkServerToken = 'YOUR_POSTMARK_SERVER_TOKEN';